import { FormattedNumber } from 'react-intl';

import { DropdownMenuPosition } from 'ui-components/components/INTERNAL/dropdown/dropdown-menu-position';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './tags-section-header-content.module.less';
import { TagsSummary } from './tags-summary';
import { TagDropdown } from '../../../tag-dropdown';
import { OrdersSidebarSectionHeaderChip } from '../orders-sidebar-section-header-chip';

/**
 * @typedef {import('../../../../prop-types/tag').TagPropType} Tag
 */

/**
 * @param {object} props
 * @param {Tag[]} props.selectedTags
 * @param {boolean} props.isSectionExpanded
 * @param {Tag[]} props.tags
 * @param {(tag: Tag) => void} props.onTagToggled
 * @returns {React.JSX.Element}
 */
export const TagsSectionHeaderContent = ({ selectedTags, isSectionExpanded, tags, onTagToggled }) => {
  return (
    <div className={style['tags-section-header-content']}>
      <div className={style['tags-section-title-and-summary']}>
        <Text textType={TextType.H4} value={messages.tags} />
        {isSectionExpanded || selectedTags.length === 0 ? (
          <OrdersSidebarSectionHeaderChip>
            <FormattedNumber value={selectedTags.length} />
          </OrdersSidebarSectionHeaderChip>
        ) : (
          <TagsSummary
            pillTextClassName={style['tags-summary-tag-text']}
            pillWrapperClassName={style['tags-summary-wrapper']}
            selectedTags={selectedTags}
          />
        )}
      </div>
      <TagDropdown
        dropdownMenuTogglerClass={style['tags-dropdown']}
        menuPosition={DropdownMenuPosition.BottomRight}
        onTagToggled={onTagToggled}
        selectedTags={selectedTags}
        tags={tags}
      />
    </div>
  );
};
